<nb-card>
    <nb-card-header>
        <div class="row justify-content-start align-items-center">
            <div class="col-2 d-flex justify-content-center">
                <app-gauge [data]="gaugeData[notification.id]" [height]="3.1" [textSize]="12"></app-gauge>
            </div>
            <div class="col">
                <strong [style.color]="notification.hexColor">{{ notification.title }}</strong>
                <span class="d-none d-md-flex notification-date text-muted">
                    {{ notification.created_datetime | date: 'short' }}
                </span>
            </div>
            <div class="col-2 d-flex justify-content-end">
                <button
                    nbButton
                    shape="rectangle"
                    status="primary"
                    nbTooltip="Shows data on usage chart"
                    (click)="navigateToBudgetRange()"
                >
                    View Data
                </button>
            </div>
        </div>
    </nb-card-header>
    <nb-card-body>
        <div class="row justify-content-start">
            <div class="col-10 d-flex justify-content-start align-items-center">
                <span class="px-4 text-muted">{{ notification.message }}</span>
            </div>
            <div class="col-2 d-flex flex-row justify-content-end">
                <button
                    class="mr-3 alert-button"
                    nbButton
                    shape="rectangle"
                    status="warning"
                    nbTooltip="Mark as Read"
                    (click)="markedRead.emit()"
                >
                    <i class="fa fa-envelope alert-button-icon"></i>
                </button>
            </div>
        </div>
    </nb-card-body>
</nb-card>
